export default "__VITE_ASSET__C2m5M$QR__"